"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HitagiConnector {
    constructor(hitagi) {
        this.hitagi = hitagi;
        this.hitagi.on('close', this._onClose.bind(this));
        this.hitagi.on('login', this._onLogin.bind(this));
        this.autoReconnect = true;
        this.reconnectionHandle = null;
        this.connect = this.connect.bind(this);
    }
    _onLogin() {
        if (this.reconnectionHandle) {
            clearInterval(this.reconnectionHandle);
            this.reconnectionHandle = null;
        }
    }
    _onClose() {
        this.maybeStartReconnection();
    }
    connect() {
        this.autoReconnect = true;
        if (!this.hitagi.logged) {
            this.hitagi.login({});
        }
        else {
            this._onLogin();
        }
    }
    disable_reconnect() {
        this.autoReconnect = false;
    }
    maybeStartReconnection() {
        if (!this.autoReconnect)
            return;
        if (this.reconnectionHandle)
            return false;
        // Reconnect now and setup periodic reconnection
        this.connect();
        this.reconnectionHandle = setInterval(this.connect, 15000);
        console.log("HitagiConnector: starting reconnection");
    }
}
exports.default = HitagiConnector;



//////////////////
// WEBPACK FOOTER
// ./node_modules/hitagi-js/build/hitagi_connector.js
// module id = ./node_modules/hitagi-js/build/hitagi_connector.js
// module chunks = main